/* tslint:disable */
/* eslint-disable */
/**
 * Keyops CEP
 * Customer Engagement Platform API documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import globalAxios, { AxiosResponse, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { RespondentDemographic } from '../models';
import { UpdateRespondentDemographicDto } from '../models';
/**
 * RespondentDemographicsApi - axios parameter creator
 * @export
 */
export const RespondentDemographicsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Update the respondent demographics name or value
         * @param {UpdateRespondentDemographicDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        respondentDemographicControllerUpdate: async (body: UpdateRespondentDemographicDto, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling respondentDemographicControllerUpdate.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling respondentDemographicControllerUpdate.');
            }
            const localVarPath = `/api/respondent-demographics/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RespondentDemographicsApi - functional programming interface
 * @export
 */
export const RespondentDemographicsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Update the respondent demographics name or value
         * @param {UpdateRespondentDemographicDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async respondentDemographicControllerUpdate(body: UpdateRespondentDemographicDto, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<RespondentDemographic>>> {
            const localVarAxiosArgs = await RespondentDemographicsApiAxiosParamCreator(configuration).respondentDemographicControllerUpdate(body, id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * RespondentDemographicsApi - factory interface
 * @export
 */
export const RespondentDemographicsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Update the respondent demographics name or value
         * @param {UpdateRespondentDemographicDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async respondentDemographicControllerUpdate(body: UpdateRespondentDemographicDto, id: string, options?: AxiosRequestConfig): Promise<AxiosResponse<RespondentDemographic>> {
            return RespondentDemographicsApiFp(configuration).respondentDemographicControllerUpdate(body, id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RespondentDemographicsApi - object-oriented interface
 * @export
 * @class RespondentDemographicsApi
 * @extends {BaseAPI}
 */
export class RespondentDemographicsApi extends BaseAPI {
    /**
     * 
     * @summary Update the respondent demographics name or value
     * @param {UpdateRespondentDemographicDto} body 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RespondentDemographicsApi
     */
    public async respondentDemographicControllerUpdate(body: UpdateRespondentDemographicDto, id: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<RespondentDemographic>> {
        return RespondentDemographicsApiFp(this.configuration).respondentDemographicControllerUpdate(body, id, options).then((request) => request(this.axios, this.basePath));
    }
}
